import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { token } from "@atlaskit/tokens";

import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const JoinableSitesSubheading = () => {
    const modalVisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    return (
        <p css={[subHeaderCss, !modalVisualUpdates && subHeaderBlackCss]}>
            <FormattedMessage
                id="signup.siteActivation.joinableSites.subheader"
                defaultMessage="Select where you’d like to get started."
            />
        </p>
    );
};

const subHeaderCss = css({
    margin: "0 auto",
    textAlign: "center"
});

const subHeaderBlackCss = css({
    color: token("color.text")
});
